import { focusCards } from '../data';

export default function FocusFeatures() {
  return (
    <section id="focus" className="border-b border-foreground-900/10 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="flex items-end justify-between gap-4 border-b border-foreground-900/10 pb-4">
          <div>
            <p className="kicker text-xs text-primary-600">焦点关注 · FOCUS</p>
            <h2 className="mt-2 font-heading text-2xl font-semibold tracking-tight text-foreground-950 md:text-3xl">
              本期焦点特稿
            </h2>
          </div>
          <span className="hidden whitespace-nowrap text-xs text-foreground-500 sm:block">6 篇编辑精选 · 持续更新</span>
        </div>

        {/* 大图卡片流 */}
        <div className="mt-6 grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-2 xl:grid-cols-3">
          {focusCards.map((c) => (
            <a href="#focus" key={c.id} className="group flex flex-col">
              <div className="overflow-hidden rounded-lg">
                <div className="aspect-[10/7] w-full overflow-hidden rounded-lg">
                  <img
                    src={c.image}
                    alt={c.title}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              </div>
              <div className="mt-3 flex items-center gap-3 text-[11px]">
                <span className="inline-flex items-center rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-900">
                  {c.label}
                </span>
                <span className="text-foreground-500">{c.time}</span>
              </div>
              <h3 className="mt-2 font-heading text-lg font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-xl">
                {c.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{c.lead}</p>
              <div className="mt-3 flex items-center gap-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{c.reads}</span>
                <span className="inline-flex items-center gap-1"><i className="ri-chat-3-line"></i>{c.comments}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}